module.exports = __webpack_public_path__ + "img/radiobutton-selected-icon.9348e683.svg";